<template>
    <sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource">
        <template slot="toolbar">
            <!-- <b-button size="sm" variant="success btn-toolbar sa-margin-right float-sm-right" @click="onClickNuvo">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button> -->
        </template>
        <!-- <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Nome:</label>
                        <b-form-input v-model="filtroConfigurazioneAgendaBox.nome" type="search" id="nome" placeholder="Nome"></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template> -->
        <template slot="table-body">
            <!-- <rsa-configurazione-diari-list-component ref="RsaConfigurazioneDiariListComponent" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData" @updateFilter="onUpdateFilter"></rsa-configurazione-diari-list-component> -->
            <agenda-box-list-component ref="cmpAgendaBoxList"></agenda-box-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import AgendaBoxListComponent from "../components/AgendaBoxListComponent.vue";

export default {
    components: { SaPageLayout, AgendaBoxListComponent },
    props: {
        utente: {
            type: Object,
        },
    },
    data() {
        return {
            pathResource: "/agendebox",
            listKey: 0,
            btnNewVisible: false,
            filtroConfigurazioneAgendaBox: { nome: "" },
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    watch: {},
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.cmpAgendaBoxList.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneAgendaBox"] = JSON.stringify(me.filtroConfigurazioneAgendaBox);
            me.loadData();
        },
    },
};
</script>

<style></style>
